import api from '@/api/API';
import { Account, AccountFilters, QueryResult } from '@/types';

export default {
  find(id: string): Promise<Account> {
    return api
      .get(`/accounts/${id}`)
      .then(response => response.data);
  },
  findAll(filters: AccountFilters): Promise<QueryResult> {
    return api
      .get('accounts', { params: filters })
      .then(response => response.data);
  },
  count(filters: AccountFilters): Promise<number> {
    const actualFilters = Object.assign({}, filters, { limit: 1 });
    return this.findAll(actualFilters).then(result => result.total);
  },
  async getNumClients(filters: AccountFilters): Promise<number> {
    return this.count(filters).then(numClients => numClients);
  },
};
